import { Box, Stack, Text } from '@chakra-ui/react';
import InputSelectMobile from '../../../../../components/Input/Mobile/Select';
import { IExemptions } from '../../../../../services/hooks/CandidateArea/useRequestMyExemption';
import CardDetailExemptionMobilePage from './cardDetail';
import { FaClipboardList } from 'react-icons/fa';
import { useMemo, useState } from 'react';
import { IDataWheelPickerSelect } from '../../../../../components/Input/Mobile/Select/whellPicker';

interface IReducedExemption {
  id: string;
  name: string;
  createdAt: string;
}

interface IOwnProps {
  data?: IExemptions[];
}

const ListSolicitationExemption: React.FC<IOwnProps> = ({ data = [] }) => {
  const [selected, setSelected] = useState<IDataWheelPickerSelect>();
  const accent = '#222';

  const selectiveProcessList = useMemo(() => {
    const itens: IReducedExemption[] = Array.from(
      data
        ?.reduce<Map<string, IReducedExemption>>((acc, item) => {
          if (!acc.has(item.selective_process_id)) {
            acc.set(item.selective_process_id, {
              id: item.selective_process_id,
              name: item.selective_process_name,
              createdAt: item.selective_process_created_at,
            });
          }
          return acc;
        }, new Map())
        ?.values() || [],
    );
    return itens?.sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
  }, [data]);

  const listBySelectiveProcess =
    selected && data?.filter((exemption) => exemption.selective_process_id === selected.id);

  return (
    <>
      <Box>
        <InputSelectMobile
          name="address_state"
          placeholderLabel="Selecione um processo seletivo"
          iconLeft={<FaClipboardList size={14} color={accent} />}
          onChangeItem={setSelected}
          selectedItem={selected}
          isExternalState
          isRequired
          listItens={selectiveProcessList}
          fontSize={12}
        />
      </Box>
      {selected && (
        <Text
          bgColor="primaryColor"
          color="white"
          boxSizing="border-box"
          py={1}
          px={5}
          fontWeight="bold"
          fontSize="small"
          h="fit-content"
          textTransform="uppercase"
        >
          {selected?.name}
        </Text>
      )}
      {(listBySelectiveProcess && (
        <>{listBySelectiveProcess?.map((item) => <CardDetailExemptionMobilePage key={item.id} item={item} />)}</>
      )) || (
        <Stack flex={1} align="center" justify="center">
          <Text fontSize="md" color="gray.400">
            Selecione um processo seletivo...
          </Text>
        </Stack>
      )}
    </>
  );
};

export default ListSolicitationExemption;
